import { render, staticRenderFns } from "./FavoriteCorporatesSelector.vue?vue&type=template&id=dc6ec576&scoped=true&"
import script from "./FavoriteCorporatesSelector.vue?vue&type=script&lang=ts&"
export * from "./FavoriteCorporatesSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FavoriteCorporatesSelector.vue?vue&type=style&index=0&id=dc6ec576&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6ec576",
  null
  
)

export default component.exports